import React from 'react';
import PropTypes from 'prop-types';

// @mui
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup
} from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

// core
import * as convert from '_core/utils/convert';
import { withLang } from '_core/hocs/withLang';
import { useCartContext } from '_core/contexts/Cart';

import { useStyle } from './style';


export const RawDeliveryWarehouseSelect = (props) => {
  const { getLangString: l } = props;
  
  
  const classes = useStyle();
  
  const cart = useCartContext();
  
  
  const renderItem = (item) => {
    const delivery = item.is_external_delivery || item.is_internal_delivery_world ? (<div>{l('r._.profile.delivery.world')}</div>)
      : item.is_internal_delivery_country ? (<div>{l('r._.profile.delivery.country')}</div>)
      : item.is_internal_delivery_region ? (<div>{l('r._.profile.delivery.region')}</div>)
      : null;
    
    const pickup = item.is_internal_pickup ? (item.address ? (<div>{l('r._.profile.delivery.pickup.address').replace('{address}', (item.locality?.value ? item.locality.value[item.locality.value.length - 1] + ', ' : '') + l(item.address))}</div>)
      : (<div>{l('r._.profile.delivery.pickup')}</div>)) : null
    
    return (
      <div className={`${classes.marginTop} ${classes.labelWrapper}`}>
        <div>{l(item.title)}</div>
        <div className={classes.marginLeft}>
          {delivery}
          {pickup}
          
          {!delivery && !pickup ? (<div>&nbsp;</div>) : null}
        </div>
      </div>
    );
  };
  
  
  const warehouseList = cart.warehouseList;
  
  return !warehouseList || warehouseList.length ? (
    <Grid item xs={12} className={classes.marginTop}>
      <FormControl component="fieldset">
        <FormLabel
          component="legend"
          className={`${classes.formLabel} ${classes.formLabelSpacing}`}
        >
          {l('global.field.object')}
        </FormLabel>
        
        {!warehouseList ? (
          <RadioGroup
            aria-label="warehouse"
            name="warehouse"
            defaultValue={null}
          >
            <FormControlLabel value={null} control={<Radio />} label={<Skeleton animation="wave" variant="rectangular" className={classes.skeleton} />} />
          </RadioGroup>
        ) : (
          <RadioGroup
            aria-label="warehouse"
            name="warehouse"
            value={convert.toString(cart.warehouse?.id)}
            onChange={(event) => cart.setWarehouse(warehouseList.find((item) => item.id == event.target.value) || null)}
          >
            {warehouseList.map((item) => (
              <FormControlLabel
                value={convert.toString(item.id)}
                checked={item.id == cart.warehouse?.id}
                control={<Radio />}
                label={renderItem(item)}
              />
            ))}
          </RadioGroup>
        )}
      </FormControl>
    </Grid>
  ) : null;
};

RawDeliveryWarehouseSelect.defaultProps = {};

RawDeliveryWarehouseSelect.propTypes = {
  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired
};

export const DeliveryWarehouseSelect = withLang(RawDeliveryWarehouseSelect);
